export const usersKeys = {
  LMS_USER_READ: 'lmsUser/read',
  LMS_USER_UPDATE: 'lmsUser/update',
  USER_CREATE: 'user/create',
  USER_PROFILE_CREATE: 'profile/create',
};